export default __webpack_public_path__ + "static/media/avatar1.ecdf9eb3.jpg";